import whitelist from 'validator/lib/whitelist';

const validCharacters = [
    // Valid Japanese character
    '０-９　\\（\\）\\ー　\\−　\\＋',
    // Valid English characters
    '0-9 \\( \\) \\+ \\-',
].join('');

const sanitizePhoneNumber = (value: string): string =>
    whitelist(value, validCharacters);

export default sanitizePhoneNumber;
